import { useEffect, useState } from 'react';

export function StatusToast({
  message,
  actionLabel,
  onAction,
  urgent = false,
  dismissAfterMs = 6_000,
}: {
  message: string;
  actionLabel?: string;
  onAction?: () => void;
  urgent?: boolean;
  dismissAfterMs?: number;
}) {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    setVisible(true);
    if (dismissAfterMs <= 0) return;
    const timer = window.setTimeout(() => setVisible(false), dismissAfterMs);
    return () => window.clearTimeout(timer);
  }, [dismissAfterMs, message]);

  if (!visible) return null;

  return (
    <div
      className={`status-toast${urgent ? ' status-toast--urgent' : ''}`}
      role={urgent ? 'alert' : 'status'}
      aria-live={urgent ? 'assertive' : 'polite'}
      aria-atomic="true"
    >
      <span>{message}</span>
      {actionLabel && onAction ? (
        <button type="button" className="status-toast-action" onClick={onAction}>{actionLabel}</button>
      ) : null}
      <button type="button" className="status-toast-dismiss" onClick={() => setVisible(false)} aria-label="Dismiss message">×</button>
    </div>
  );
}
